import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import SmartApprove from "../shared/smart-approve/index.vue";
import { Icon, Button, Upload, Modal } from "@h3/antd-vue";
import { ApproveOpinionControl } from "../../controls";
let ApproveOpinion = class ApproveOpinion extends ApproveOpinionControl {
    constructor() {
        super(...arguments);
        this.uploading = false;
    }
    get val() {
        return this.ctrl.value || {};
    }
    handlePreview() { }
    setControl() {
        this.handleValueChange(this.ctrl.value);
    }
    handleValueChange(value) {
        if (this.uploading) {
            this.uploading = false;
            return;
        }
        if (value && value.resources) {
            this.fileList = value.resources.map((x) => this.map(x));
        }
    }
    showError(msg) {
        this.$message.error(msg);
    }
    beforeUpload(file) {
        return this.checkFile(file, this.showError);
    }
    checkFile(file, showError) {
        if (!this.checkFileType(file.name, showError)) {
            return false;
        }
        //二开S
        // if (!this.checkFileSize(file, showError)) {
        //   return false;
        // }
        //二开E
        return true;
    }
    onChange(info) {
        if (!this.checkFile(info.file)) {
            return;
        }
        this.fileList = info.fileList;
        this.uploading = true;
        const resources = info.fileList
            .filter(f => f.status === "done")
            .map(f => f.response.data);
        this.ctrl.value = Object.assign(this.val, {
            resources
        });
    }
    onInput(val) {
        // this.ctrl.value.content = val;
        this.ctrl.value = Object.assign(this.val, {
            content: val
        });
    }
    // onCheckboxChange(checked: boolean) {
    //   this.ctrl.value.saveCommon = checked;
    // }
    onSelectFocus() {
        super.search("");
    }
};
ApproveOpinion = tslib_1.__decorate([
    Component({
        name: "approve-opinion",
        components: {
            AIcon: Icon,
            AButton: Button,
            AUpload: Upload,
            AModal: Modal,
            SmartApprove
        }
    })
], ApproveOpinion);
export default ApproveOpinion;
